<template>
    <div id="funcionario-cadastro">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div class="row">
                    <div class="col s12 m12 l12">
                    <TituloPagina class="header" titulo="Cadastro de funcionário" />
                        <div class="card-panel">
                            <!-- <h4 class="header">Cadastro de funcionário</h4> -->
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <formulario-pessoa @newdata="handleDataPessoa($event)"></formulario-pessoa>
                                    <formulario-endereco id="endereco" @newdata="handleDataEmpresa($event)"></formulario-endereco>
                                    <formulario-funcionario @input="handleDataFuncionario($event)"></formulario-funcionario>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right" type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
    import FormularioPessoa from '@/components/common/FormularioPessoa';
    import FormularioEndereco from '@/components/common/FormularioEndereco';
    import FormularioFuncionario from '@/components/usuarios/Formulario';
    import TituloPagina from '@/components/common/TituloPagina';
    import { post } from '@/helpers/api';
    import Message from '@/helpers/message';
    import { DONO, GERENTE, ESPECIALISTA, MASTER, PARCEIRO } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';
    import
    {
        isMultiEmpresa
    }
    from '@/environment';
    export default {
        components: {
            FormularioPessoa,
            FormularioEndereco,
            TituloPagina,
            FormularioFuncionario
        },
        data: () => ({
            pessoa: {
                pessoa_nome: '',
                pessoa_cpf: '',
                pessoa_email: '',
                pessoa_sexo: '',
                pessoa_telefone: '',
                pessoa_celular: '',
                pessoa_data_nascimento: '',
                pessoa_profissao: '',
                pessoa_estado_civil: '',
                pessoa_filhos: '',
                pessoa_observacao: '',
            },
            endereco: {
                endereco_cep: '',
                endereco_estado: '',
                endereco_cidade: '',
                endereco_bairro: '',
                endereco_logradouro: '',
                endereco_numero: '',
                endereco_complemento: '',
            },
            funcionario: {
                empresa_id: '',
                funcionario_cargo_id: '',
                usuario: '',
                senha: ''
            }
        }),
        created(){
            // verifica se pode acessar componente
            //const arrayAcessos = isMultiEmpresa ? [DONO, GERENTE, ESPECIALISTA, PARCEIRO] : [DONO];

             // verifica se pode acessar componente
            if (Auth.getCargoUsuario() !== MASTER && [DONO, GERENTE, ESPECIALISTA, PARCEIRO].indexOf(Auth.getCargoUsuario()) === -1) {
                this.$router.push('/sempermissao');
            }

        },
        methods: {
            validateForm() {
                let validForm = true;
                if (this.pessoa.pessoa_nome === '') {
                    Message.messageError('Campo Nome é obrigatório');
                    validForm = false;
                }
                if (this.pessoa.pessoa_email === '') {
                    Message.messageError('Campo Email é obrigatório');
                    validForm = false;
                }
                if (this.funcionario.empresa_id === '') {
                    this.funcionario.empresa_id = 1;
                    /*Message.messageError('Campo Empresa é obrigatório');
                    validForm = false;*/
                }
                if (this.funcionario.funcionario_cargo_id === '') {
                    Message.messageError('Campo Cargo é obrigatório');
                    validForm = false;
                }
                if (this.funcionario.usuario === '') {
                    Message.messageError('Campo Usuário é obrigatório');
                    validForm = false;
                }
                if (this.funcionario.senha === '') {
                    Message.messageError('Campo Senha é obrigatório');
                    validForm = false;
                }
                if (Auth.getCargoUsuario2() == 3 || Auth.getCargoUsuario2() == 2) {
                this.$router.push('/sempermissao');
                }
                return validForm;
            },
            save() {
                if (! this.validateForm()) {
                    return false;
                }

                let dataNascimento = null;
                if (this.pessoa.pessoa_data_nascimento !== '') {
                    dataNascimento = moment(this.pessoa.pessoa_data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD')
                }

                let postData = {
                    pessoa_nome: this.pessoa.pessoa_nome,
                    pessoa_cpf: this.removerCaracteres(this.pessoa.pessoa_cpf),
                    pessoa_email: this.pessoa.pessoa_email,
                    pessoa_sexo: this.pessoa.pessoa_sexo,
                    pessoa_telefone: this.removerCaracteres(this.pessoa.pessoa_telefone),
                    pessoa_celular: this.removerCaracteres(this.pessoa.pessoa_celular),
                    pessoa_data_nascimento: dataNascimento,
                    pessoa_profissao: this.pessoa.pessoa_profissao,
                    pessoa_estado_civil: this.pessoa.pessoa_estado_civil,
                    pessoa_filhos: this.pessoa.pessoa_filhos,
                    pessoa_observacao: this.pessoa.pessoa_observacao,
                    endereco_cep: this.removerCaracteres(this.endereco.endereco_cep),
                    endereco_estado: this.endereco.endereco_estado,
                    endereco_cidade: this.endereco.endereco_cidade,
                    endereco_bairro: this.endereco.endereco_bairro,
                    endereco_logradouro: this.endereco.endereco_logradouro,
                    endereco_numero: this.removerCaracteres(this.endereco.endereco_numero),
                    endereco_complemento: this.endereco.endereco_complemento,
                    empresa_id: this.funcionario.empresa_id,
                    funcionario_cargo_id: this.funcionario.funcionario_cargo_id,
                    usuario: this.funcionario.usuario,
                    senha: this.funcionario.senha,
                    empresas_ids: this.funcionario.empresas_ids,
                };

                let self = this;

                post('funcionario', postData).then(function (response) {
                    Message.messageSuccess('Usuário salvo com sucesso.');
                    self.$router.push('/usuarios');
                }).catch(function (response) {
                    Message.messageError(response.data.statusMessage);
                });
            },
            handleDataPessoa: function(e) {
                [
                    this.pessoa.pessoa_nome,
                    this.pessoa.pessoa_cpf,
                    this.pessoa.pessoa_email,
                    this.pessoa.pessoa_sexo,
                    this.pessoa.pessoa_telefone,
                    this.pessoa.pessoa_celular,
                    this.pessoa.pessoa_data_nascimento,
                    this.pessoa.pessoa_profissao,
                    this.pessoa.pessoa_estado_civil,
                    this.pessoa.pessoa_filhos,
                    this.pessoa.pessoa_observacao,
                ] = e;
            },
            handleDataEndereco: function(e) {
                [
                    this.endereco.endereco_cep,
                    this.endereco.endereco_estado,
                    this.endereco.endereco_cidade,
                    this.endereco.endereco_bairro,
                    this.endereco.endereco_logradouro,
                    this.endereco.endereco_numero,
                    this.endereco.endereco_complemento,
                ] = e;
            },
            handleDataFuncionario(e) {
                this.funcionario = e;
            },
            removerCaracteres(string) {
                let stringReplace;
                stringReplace = string.split('(').join('');
                stringReplace = stringReplace.split(')').join('');
                stringReplace = stringReplace.split('-').join('');
                stringReplace = stringReplace.split('.').join('');
                stringReplace = stringReplace.split('_').join('');
                return stringReplace;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/usuarios/Cadastro.vue